// =============================================================================
// PORTAL API SERVICE (portalApi.js)
// =============================================================================
// API calls for the CDiC Upload Portal tab.
// Adapted from cdic-portal-react/client/src/services/api.js
//
// KEY CHANGE: Uses relative URLs (/api/...) because the visualizer's
// package.json has "proxy": "http://localhost:5000" which forwards
// /api/* requests to the Express backend on port 5000.
// =============================================================================

const API_BASE = '/api';

// --- Authentication ---
export async function login(username, password) {
  const response = await fetch(`${API_BASE}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ username, password }),
  });
  return response.json();
}

export async function logout() {
  const response = await fetch(`${API_BASE}/auth/logout`, {
    credentials: 'include',
  });
  return response.json();
}

export async function checkSession() {
  const response = await fetch(`${API_BASE}/auth/session`, {
    credentials: 'include',
  });
  return response.json();
}

// --- Password Management ---
export async function forgotPassword(email) {
  const response = await fetch(`${API_BASE}/password/forgot`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ email }),
  });
  return response.json();
}

export async function resetPassword(email, confirmationCode, newPassword) {
  const response = await fetch(`${API_BASE}/password/reset`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({
      email,
      confirmation_code: confirmationCode,
      new_password: newPassword,
    }),
  });
  return response.json();
}

export async function setNewPassword(newPassword) {
  const response = await fetch(`${API_BASE}/password/new-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ new_password: newPassword }),
  });
  return response.json();
}

// --- Upload ---
export async function getUploadInfo() {
  const response = await fetch(`${API_BASE}/upload/info`, {
    credentials: 'include',
  });
  return response.json();
}

export async function uploadFile(file) {
  const formData = new FormData();
  formData.append('file', file);
  const response = await fetch(`${API_BASE}/upload`, {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });
  return response.json();
}
